export const LIST_USER_PERMISSIONS = "userpermission/getuserforuser";
export const UPDATE_USER_PERMISSIONS = (id) =>
  `userpermission/update?userId=${id}`;
export const GET_USER_PERMISSIONS_BY_ID = (id) => `userpermission/get?id=${id}`;
